/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: featureCategoriesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Class of Services module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import {
  FEATURE_CATEGORIES_ENDPOINT,
  requestFeatureCategoriesApi,
} from './api';

/**
 * Shared helpers for Feature Categories module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Feature Category in the form.
 * Pattern: /pbx/class-of-services/feature-categories/new?duplicate={id}
 */
export const getFeatureCategoryDuplicateUrl = (id: string | number): string =>
  `/pbx/class-of-services/feature-categories/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Feature Category id.
 */
export const navigateToFeatureCategoryDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getFeatureCategoryDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Feature Category by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteFeatureCategoryById = async (id: string | number): Promise<void> => {
  await requestFeatureCategoriesApi<null>(
    `${FEATURE_CATEGORIES_ENDPOINT}/${id}`,
    'Failed to delete Feature Category',
    { method: 'DELETE' },
  );
};



